<template>
  <div class="search-area-wrapper">
    <!-- 定义 SVG 渐变，供 AI 研判按钮图标引用（与 homemain1.vue 一致） -->
    <svg width="0" height="0" style="position: absolute">
      <defs>
        <linearGradient id="btn-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#2563EB" />
          <stop offset="100%" stop-color="#8B5CF6" />
        </linearGradient>
      </defs>
    </svg>

    <!-- 顶部标签与AI按钮 -->
    <div class="search-tabs flex justify-between items-center w-full">
      <div class="segmented-control">
        <button
          @click="handelChangeTabType('multi')"
          :class="['segment-btn transition', { active: activeTab === 'multi' }]"
        >
          <svg
            class="segment-icon"
            width="14"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="18" cy="5" r="2.5" />
            <circle cx="6" cy="12" r="2.5" />
            <circle cx="18" cy="19" r="2.5" />
            <path d="M8.25 10.85l7.5-4.05M8.25 13.15l7.5 4.05" />
          </svg>
          {{ $t("home.searchInput.canvasTypes.multi") }}
          <el-popover
            placement="top"
            width="250"
            trigger="hover"
            popper-class="custom-popover"
          >
            <div class="popover-desc">
              {{ $t("components.currencyDescription.multi.description") }}
            </div>
            <div class="popover-box">
              <div class="pop-title-row">
                {{ $t("components.currencyDescription.multi.supportData") }}
                <div class="pop-icons">
                  <CanvasIcons name="blockchain_1" />
                  <CanvasIcons name="blockchain_2" />
                  <CanvasIcons name="blockchain_3" />
                </div>
              </div>
              <div class="pop-text">
                {{ $t("components.currencyDescription.multi.supportDetails") }}
              </div>
            </div>
            <i
              slot="reference"
              class="el-icon-question segment-help"
              @click.stop
            ></i>
          </el-popover>
        </button>
        <button
          @click="handelChangeTabType('single')"
          :class="[
            'segment-btn transition',
            { active: activeTab === 'single' },
          ]"
        >
          <i class="fas fa-route"></i>
          {{ $t("home.searchInput.canvasTypes.single") }}
          <el-popover
            placement="top"
            width="250"
            trigger="hover"
            popper-class="custom-popover"
          >
            <div class="popover-desc">
              {{ $t("components.currencyDescription.single.description") }}
            </div>
            <div class="popover-box">
              <div class="pop-title-row">
                {{ $t("components.currencyDescription.single.supportData") }}
                <div class="pop-icons">
                  <CanvasIcons name="blockchain_1" />
                  <CanvasIcons name="blockchain_2" />
                  <CanvasIcons name="blockchain_3" />
                  <CanvasIcons name="btc" />
                  <CanvasIcons name="heco" />
                  <CanvasIcons name="polygon" />
                </div>
              </div>
              <div class="pop-text">
                {{ $t("components.currencyDescription.single.supportDetails") }}
              </div>
            </div>
            <i
              slot="reference"
              class="el-icon-question segment-help"
              @click.stop
            ></i>
          </el-popover>
        </button>
        <button
          @click="handelChangeTabType('detail')"
          :class="[
            'segment-btn transition',
            { active: activeTab === 'detail' },
          ]"
        >
          <i class="fas fa-id-card"></i>
          {{ $t("home.searchInput.tabs.dataDetail") }}
        </button>
      </div>
      <!-- AI 研判按钮 -->
      <button
        @click="handelChangeTabType('assessment')"
        :class="['btn-ai transition', { active: activeTab === 'assessment' }]"
      >
        <svg class="icon-sparkles" width="16" height="16" viewBox="0 0 24 24">
          <path
            d="M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5L12 2zM19 14l.75 2.75L22.5 17.5l-2.75.75L19 21l-.75-2.75L15.5 17.5l2.75-.75L19 14zM6 14l.75 2.75L9.5 17.5l-2.75.75L6 21l-.75-2.75L2.5 17.5l2.75-.75L6 14z"
          />
        </svg>
        {{ $t("home.searchInput.tabs.aiAssessment") }}
      </button>
    </div>

    <!-- AI 研判面板 -->
    <div
      v-if="activeTab === 'assessment'"
      class="search-outer-wrapper ai-wrapper"
    >
      <div class="ai-inner transition">
        <aiAssessment @historicalRecords="historicalRecords"></aiAssessment>
      </div>
    </div>

    <!-- 搜索栏 (画布分析 / 数据详情) -->
    <div v-else class="search-outer-wrapper">
      <div
        ref="searchContainer"
        :class="['search-inner-container', { 'has-selector': isCanvasTab }]"
      >
        <!-- 输入框 -->
        <input
          v-if="isCanvasTab"
          type="text"
          v-model="canvasAddress"
          @input="onInput($event.target.value)"
          @focus="showHistory"
          @blur="hideHistory"
          @keyup.enter="canvasanalysis"
          class="search-input"
          :placeholder="placeholderText"
        />
        <input
          v-else
          type="text"
          v-model="detailAddress"
          @input="onInput($event.target.value)"
          @focus="showHistory"
          @blur="hideHistory"
          @keyup.enter="datadetails"
          class="search-input"
          :placeholder="placeholderText"
        />

        <!-- 清除按钮 -->
        <div
          v-if="
            (isCanvasTab && canvasShowBtn) ||
            (activeTab === 'detail' && detailShowBtn)
          "
          @click="clearablebtn(activeTab)"
          class="btn-clear transition"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
          </svg>
        </div>

        <!-- 搜索按钮 -->
        <button
          v-if="isCanvasTab"
          class="btn-search transition"
          :class="{ active: canvasShowBtn && !canvasLoading }"
          @click="canvasanalysis"
        >
          <i :class="canvasLoading ? 'el-icon-loading' : 'el-icon-search'"></i>
        </button>
        <button
          v-else
          class="btn-search transition"
          :class="{ active: detailShowBtn && !detailLoading }"
          @click="datadetails"
        >
          <i :class="detailLoading ? 'el-icon-loading' : 'el-icon-search'"></i>
        </button>
      </div>
    </div>

    <!-- 搜索底部辅助 -->
    <div
      v-if="activeTab !== 'assessment'"
      class="search-footer flex justify-center"
    >
      <div class="flex items-center gap-6">
        <div class="supported-networks flex items-center gap-2">
          <span>支持网络:</span>
          <div class="supported-network-list">
            <span
              v-for="network in supportedNetworkItems"
              :key="network.name"
              class="supported-network-item"
            >
              <CanvasIcons :name="network.icon" />
              <span class="supported-network-name">{{ network.name }}</span>
            </span>
          </div>
        </div>
        <div class="divider-v"></div>
        <div class="footer-action transition" @click="useExampleAddress">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
          {{ $t("home.searchInput.actions.exampleData") }}
        </div>
      </div>
    </div>

    <!-- AI 建议按钮 - activeTab === 'assessment' 时显示 -->
    <div v-else class="flex gap-3 ai-suggestion-box">
      <button class="ai-suggestion transition" @click="fillExample1">
        {{ $t("components.aiAssessment.examples.example1") }}
      </button>
      <button class="ai-suggestion transition" @click="fillExample2">
        {{ $t("components.aiAssessment.examples.example2") }}
      </button>
    </div>

    <!-- 历史记录 -->
    <SearchHistory
      :isShow="isShowHistory && activeTab !== 'assessment'"
      :list="historyList"
      @select="selectHistory"
    />

    <!-- 多链选择弹窗 -->
    <div v-if="morechain" id="moreselectbox">
      <multiple-chains
        :addresslength="addresslength"
        :addressarray="addressarray"
        :selectwidth="selectwidth"
        @handlejumpdetails="handlejumpdetails"
      ></multiple-chains>
    </div>

    <!-- BTC画布弹窗 -->
    <Btcdialog
      :BTCresdata="BTCresdata"
      :temporarilSingleyCanvas="temporarilSingleyCanvas"
      :visible="btcDialogVisible"
      @close="closeBTCDialog"
      @addcanvasfn="jumpCanvas"
    />

    <!-- AI 对话记录弹窗 -->
    <!-- <DialogHistory
      :visible.sync="showHistoryDialog"
      @updateVisible="updateVisible"
      @getMessageList="getMessageList"
    /> -->
  </div>
</template>

<script>
import multipleChains from "@/views/newtheme/newhome/multipleChainsBlack.vue";
import { Analysisvertex } from "@/aips/addressanalysis";
import CanvasIcons from "@/components/icons/CanvasIcons.vue";
import { homeDataMultiSearch, historicalRecords } from "@/aips/homepage";
import { pageBitcoinAddressTransaction } from "@/aips/canvas/singlecurrency";
import Btcdialog from "@/views/newtheme/newcanvas/singleCurrencyCanvas/BTCDialog.vue";
import dayjs from "dayjs";
import aiAssessment from "@/views/newtheme/newhome/aiAssessment.vue";
import SearchHistory from "./components/SearchHistory.vue";
import { getSafeUserRoles } from "@/utils/safeLocalStorage";
// import DialogHistory from "@/views/newtheme/newhome/DialogHistory.vue";
export default {
  name: "SearchInput",
  components: {
    // DialogHistory,
    multipleChains,
    CanvasIcons,
    Btcdialog,
    aiAssessment,
    SearchHistory,
  },
  // props: ["userdisable"],
  data() {
    return {
      userdisable: false,
      // showHistoryDialog: true,
      singleCanvasQueryData: null,
      temporarilSingleyCanvas: true,
      btcDialogVisible: false, // 控制BTC画布弹窗显示
      BTCresdata: null, //BTC相关数据
      activeTab: this.userdisable ? "detail" : "multi",
      aiQuery: "", // AI 研判输入内容
      showHistoryDialog: false, // 对话记录弹窗显示状态
      canvasAddress: "",
      canvasLoading: false,
      canvasShowBtn: false,
      detailAddress: "",
      detailLoading: false,
      detailShowBtn: false,
      morechain: false,
      addresslength: 0,
      addressarray: [],
      selectwidth: 720,
      // placeholderText 现在通过计算属性获取
      isShowHistory: false,
      historyList: [],
      historyLoading: false,
      canvasType: "multi",
      exampleaddress: "TAdXDYonG6vHDm9qPPMvPeNP1k1b1G4FvS",
    };
  },
  computed: {
    isCanvasTab() {
      return this.activeTab === "multi" || this.activeTab === "single";
    },
    // 占位符文本
    placeholderText() {
      console.log(this.canvasType);
      if (this.activeTab === "single") {
        return this.$t("home.searchInput.placeholders.singleCurrency");
      } else {
        return this.$t("home.searchInput.placeholders.multiCurrency");
      }
    },
    supportedNetworkItems() {
      if (this.activeTab === "single") {
        return [
          { name: "ETH", icon: "blockchain_1" },
          { name: "TRON", icon: "blockchain_3" },
          { name: "BSC", icon: "blockchain_2" },
          { name: "BTC", icon: "btc" },
          { name: "Heco", icon: "heco" },
          { name: "Polygon", icon: "polygon" },
        ];
      } else if (this.activeTab === "detail") {
        return [
          { name: "ETH", icon: "blockchain_1" },
          { name: "TRON", icon: "blockchain_3" },
          { name: "BSC", icon: "blockchain_2" },
          { name: "BTC", icon: "btc" },
          { name: "Heco", icon: "heco" },
        ];
      }
      // multi
      return [
        { name: "ETH", icon: "blockchain_1" },
        { name: "TRON", icon: "blockchain_3" },
        { name: "BSC", icon: "blockchain_2" },
      ];
    },
  },
  watch: {
    // 监听语言变化，强制更新组件
    "$i18n.locale"() {
      this.$forceUpdate();
    },
  },
  methods: {
    // 打开对话记录
    historicalRecords(bool) {
      this.showHistoryDialog = bool !== undefined ? bool : true;
    },
    // 更新弹窗可见性
    updateVisible() {
      this.showHistoryDialog = false;
    },
    // AI 建议示例1
    fillExample1() {
      this.aiQuery = this.$t("components.aiAssessment.examples.fullExample1");
      this.$nextTick(() => {
        this.handleAiSubmit();
      });
    },
    // AI 建议示例2
    fillExample2() {
      this.aiQuery = this.$t("components.aiAssessment.examples.fullExample2");
      this.$nextTick(() => {
        this.handleAiSubmit();
      });
    },
    // AI 提交分析
    handleAiSubmit() {
      if (!this.aiQuery.trim()) return;
      // 跳转到 AI canvas 分析页面
      let caseAnalysisone = this.$router.resolve({
        path: "/AIcanvas",
        query: {
          temporarilycanvas: true,
          inputContent: JSON.stringify(this.aiQuery),
        },
      });
      window.openByAnchor(caseAnalysisone.href);
    },
    // 获取会话详情（从对话记录组件回调）
    getMessageList(item) {
      if (item) {
        let surveySuggest = {
          conversationId: item.conversationId,
          canvasid: item.canvasId ? item.canvasId : null,
          branchId: item.branchId ? item.branchId : null,
          title: item.title || null,
          id: null,
        };
        sessionStorage.surveySuggest = JSON.stringify(surveySuggest);

        let caseAnalysisone = this.$router.resolve({
          path: "/AIcanvas",
          query: {
            temporarilycanvas: true,
            conversationId: item.conversationId,
            id: item.canvasId ? item.canvasId : null,
            branchId: item.branchId ? item.branchId : null,
          },
        });
        window.openByAnchor(caseAnalysisone.href);
      }
    },
    //切换tab
    handelChangeTabType(tab) {
      // 支持传入字符串或对象
      const newTab =
        typeof tab === "string" ? tab : tab?.name || this.activeTab;
      console.log(newTab, "newTab");
      console.log(this.activeTab, "this.activeTab");

      // AI 研判：点击新开页面跳转到第三方网站的 SSO 授权页
      if (newTab === "assessment") {
        const ssoRoute = this.$router.resolve({
          path: "/sso",
          query: { siteId: "agent" },
        });
        // 复用公共方法 window.openByAnchor：新开标签页，且会自动追加认证接力参数
        window.openByAnchor(ssoRoute.href, "_blank");
        return;
      }

      if (this.userdisable && (newTab === "multi" || newTab === "single")) {
        // 初始角色用户受限：弹「专业版提示」弹窗，关闭后统一回到详情页
        this.$tbProFeature().then(() => {
          this.activeTab = "detail";
        });
        return;
      }
      if (newTab) {
        this.activeTab = newTab;
      }
      if (this.isCanvasTab) {
        this.canvasType = this.activeTab;
        this.$emit("changeHomeText", false);
        this.canvasAddress = this.detailAddress;
        if (this.canvasAddress !== "") {
          this.showHistory();
          this.canvasShowBtn = true;
        } else {
          this.canvasShowBtn = false;
        }
      } else if (this.activeTab == "assessment") {
        //AI研判
        this.$emit("changeHomeText", true);
      } else {
        this.$emit("changeHomeText", false);
        this.detailAddress = this.canvasAddress;
        if (this.detailAddress !== "") {
          this.showHistory();
          this.detailShowBtn = true;
        } else {
          this.detailShowBtn = false;
        }
      }
    },
    //示例数据
    useExampleAddress() {
      if (this.isCanvasTab) {
        this.canvasAddress = this.exampleaddress;
        this.canvasShowBtn = true;
      } else {
        this.detailAddress = this.exampleaddress;
        this.detailShowBtn = true;
      }
      this.canvasShowBtn = true;
      this.showHistory();
    },
    onInput(v) {
      if (this.isCanvasTab) {
        this.canvasAddress = v;
        this.canvasShowBtn = v !== "";
      } else {
        this.detailAddress = v;
        this.detailShowBtn = v !== "";
      }
      this.showHistory(v);
    },
    clearablebtn() {
      if (this.isCanvasTab) {
        this.canvasAddress = "";
        this.canvasShowBtn = false;
      } else {
        this.detailAddress = "";
        this.detailShowBtn = false;
      }
    },
    // 画布分析
    canvasanalysis() {
      if (this.userdisable) return;
      const address = this.canvasAddress;
      if (!address) return;
      const data = {
        input: address,
        searchCategory: "CANVAS_ANALYSIS_SEARCH",
        typeCode: this.canvasType == "multi" ? "多币种画布" : "单币种画布",
      };
      this.canvasLoading = true;
      homeDataMultiSearch(data).then((res) => {
        this.canvasLoading = false;
        console.log("看我的数据");
        console.log(res.data);
        if (this.canvasType == "multi") {
          //多币种
          sessionStorage.topathUrl = null;
          let addresslist = { dealaddress: address };
          let caseAnalysisone = this.$router.resolve({
            path: "/canvaslist/newcanvas",
            query: {
              temporarilycanvas: true,
              addresslist: JSON.stringify(addresslist),
            },
          });
          window.openByAnchor(caseAnalysisone.href);
        } else {
          //单币种
          if (res.data.resultType == 1) {
            //地址
            if (res.data.resultDatas.length > 1) {
              //多条链
              this.addressarray = res.data.resultDatas;
              this.morechain = true;
              this.addresslength = res.data.resultDatas.length;
            } else {
              this.singleCanvasQueryData = res.data.resultDatas[0];
              this.temporarilCanvasJump(this.singleCanvasQueryData);
            }
          } else if (res.data.resultType == 2) {
            //调证用户
            // this.$message({
            //   message: "单币种画布暂不支持调证用户查询",
            //   type: "warning",
            //   duration: 2000,
            // });
          } else if (res.data.resultType == 3) {
            //哈希
            this.singleCanvasQueryData = res.data.resultDatas[0];
            this.temporarilCanvasJump(this.singleCanvasQueryData);
          }
        }
      });
    },
    temporarilCanvasJump(data) {
      console.log("单币种跳转");
      console.log(data);

      if (data.blockchain.code === "BITCOIN") {
        pageBitcoinAddressTransaction({
          address: this.canvasAddress,
          blockchain: data.blockchain.code,
        }).then((res) => {
          console.log(res);
          if (res.data.content.length > 0) {
            let BTCData = {
              data: res.data,
              // params: data,
              address: this.canvasAddress,
              blockchain: data.blockchain.code,
            };
            this.openBtcDialog(BTCData);
          } else {
            this.singleCanvasQueryData.address = this.canvasAddress;
            this.jumpCanvas();
          }
        });
      } else {
        this.jumpCanvas();
      }
    },
    jumpCanvas(row) {
      console.log("跳转画布");
      console.log(row);

      if (row) {
        this.singleCanvasQueryData.address = row.hash;
      }
      console.log(this.singleCanvasQueryData);
      if (this.singleCanvasQueryData?.blockchain?.code) {
        this.singleCanvasQueryData.blockchain =
          this.singleCanvasQueryData.blockchain.code;
      }
      sessionStorage.topathUrl = null;
      //单币种画布跳转
      let caseAnalysisone = this.$router.resolve({
        path: "/canvaslist/newcanvas",
        query: {
          type: "SINGLE_CURRENCY_CANVAS",
          temporarilycanvas: true,
          temporarilycanvasData: JSON.stringify(this.singleCanvasQueryData),
        },
      });
      window.openByAnchor(caseAnalysisone.href);
    },
    //BTC加入画布
    openBtcDialog(params) {
      console.log("是否执行");
      console.log(params);

      params.data.content.forEach((item) => {
        if (item.txTime) {
          item.txTime = dayjs.unix(item.txTime).format("YYYY-MM-DD HH:mm");
        }
      });
      this.btcDialogVisible = true;
      this.BTCresdata = params;
    },

    closeBTCDialog() {
      this.btcDialogVisible = false;
    },
    // 数据详情
    datadetails() {
      console.log("我是数据详情--执行");
      console.log(this.detailAddress);
      const address = this.detailAddress;
      if (!address) return;
      this.detailLoading = true;
      const data = {
        input: address,
        searchCategory: "DATA_DETAIL_SEARCH",
      };
      homeDataMultiSearch(data).then((res) => {
        this.detailLoading = false;
        if (res.data.resultType == 1) {
          if (res.data.resultDatas.length > 1) {
            this.addressarray = res.data.resultDatas;
            this.morechain = true;
            this.addresslength = res.data.resultDatas.length;
          } else {
            const data = res.data.resultDatas[0];
            this.jumpdetails(data);
          }
        } else if (res.data.resultType == 2) {
          this.$router.push({
            path: `/home/userdetails-refactor/${address}`,
            query: { searchcontent: address },
          });
        } else if (res.data.resultType == 3) {
          const data = JSON.stringify(res.data.resultDatas[0]);
          this.$router.push({
            path: `/home/transactiondetails/${res.data.resultDatas[0].hash}`,
            query: { hashdata: data },
          });
        }
      });
    },
    jumpdetails(v) {
      let vertexRequest = {
        address: v.address,
        blockchain: v.blockchain.code,
      };
      Analysisvertex(vertexRequest).then((res) => {
        if (res.code == 200) {
          if (res.data.vertices.length > 0) {
            this.$emit("goanalysis", v);
          } else {
            this.$tbMessage({
              text: this.$t("home.searchInput.messages.noAddress"),
              type: "warning",
              duration: 1000,
            })
          }
        }
      });
    },
    handlejumpdetails(val) {
      console.log("点击");
      console.log(val);
      if (this.isCanvasTab) {
        //跳转画布
        this.singleCanvasQueryData = { ...val };
        this.jumpCanvas();
      } else {
        this.jumpdetails(val);
      }
    },
    showHistory() {
      let searchCategory = this.isCanvasTab
        ? "CANVAS_ANALYSIS_SEARCH"
        : "DATA_DETAIL_SEARCH";
      this.historyLoading = true;
      let data = this.isCanvasTab ? this.canvasAddress : this.detailAddress;
      historicalRecords(searchCategory, data)
        .then((res) => {
          console.log(res);
          this.historyList = [...res.data];
        })
        .finally(() => {
          this.historyLoading = false;
        });
      this.isShowHistory = true;
    },
    hideHistory() {
      setTimeout(() => {
        this.isShowHistory = false;
      }, 200);
    },
    selectHistory(address) {
      if (this.isCanvasTab) {
        this.canvasAddress = address;
        this.canvasShowBtn = true;
        this.canvasanalysis();
      } else {
        this.detailAddress = address;
        this.detailShowBtn = true;
        this.datadetails();
      }
    },
  },
  mounted() {
    console.log(this.userdisable);
    let userroles = getSafeUserRoles();
    console.log(userroles);
    userroles.sort(function (a, b) {
      return b.weight - a.weight;
    });

    if (userroles[0].label == "initial_role") {
      this.userdisable = true;
    } else {
      this.userdisable = false;
    }
    if (this.userdisable) {
      this.activeTab = "detail";
    } else {
      const canvasType = this.$route.query.canvasType;
      if (canvasType === "single" || canvasType === "multi") {
        this.handelChangeTabType(canvasType);
      }
    }
    document.addEventListener("click", (e) => {
      const moreselectbox = document.getElementById("moreselectbox");
      if (moreselectbox) {
        if (!moreselectbox.contains(e.target)) {
          this.morechain = false;
        }
      }
      // 点击输入框区域外时隐藏搜索历史
      if (
        this.$refs.searchContainer &&
        !this.$refs.searchContainer.contains(e.target)
      ) {
        this.isShowHistory = false;
      }
    });
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/newhomepage/searchinput.less";
::v-deep .el-select-dropdown__item {
  padding: 0 8px;
}
</style>
<style lang="less">
@import "@/assets/css/publicStyle/dialog.less";
@import "@/assets/css/publicStyle/input.less";
@import "@/assets/css/publicStyle/button.less";
@import "@/assets/css/publicStyle/select.less";
@import "@/assets/css/publicStyle/table.less";
@import "@/assets/css/newhomepage/tabsStyle.less";
@import "@/assets/css/newhomepage/homemain-common.less";
</style>
